import React, { useMemo } from "react";

import clsx from "clsx";

import { NotificationType } from "./grouped-notifications";

export type MMMNotificationProps = {
  mainText: string;
  subText: string;
  type: NotificationType;
  PillComponent: React.ReactNode;
  RightSideComponent: React.ReactNode;
  onHover?: (isHovering: boolean) => void;
  disableBorder?: boolean;
  size?: "sm" | "lg";
};

export function Notification({
  mainText,
  subText,
  type,
  PillComponent,
  RightSideComponent,
  onHover,
  disableBorder,
  size = "lg",
}: MMMNotificationProps) {
  const NotificationGraphic = useMemo(() => {
    switch (type) {
      case NotificationType.INFO:
        return <i className="fa-solid fa-circle-check text-alien"></i>;
      case NotificationType.WARNING:
        return <i className="fa-solid fa-triangle-exclamation text-sun+2"></i>;
      case NotificationType.DANGER:
        return <i className="fa-solid fa-circle-exclamation text-mars"></i>;
    }
  }, [type]);

  return (
    <div
      className={clsx(
        "w-full flex justify-between items-center rounded",
        "px-5 py-6",
        {
          "h-15": size === "lg",
          "h-10": size === "sm",
          "bg-alien-2": type === NotificationType.INFO,
          "bg-v2-highlight-pending text-v2-primary":
            type === NotificationType.WARNING,
          "bg-mars-2": type === NotificationType.DANGER,
          "border border-v2-secondary": !disableBorder,
        },
      )}
      onMouseEnter={() => onHover?.(true)}
      onMouseLeave={() => onHover?.(false)}
    >
      <div className={clsx("flex justify-start items-center gap-4")}>
        <div className={clsx({ "text-xl": size === "lg" })}>
          {NotificationGraphic}
        </div>
        <div className="flex justify-start items-center gap-2">
          <span
            className={clsx("font-semibold", {
              "text-sm": size === "lg",
              "text-xs": size === "sm",
            })}
          >
            {mainText}
          </span>
          <span
            className={clsx({
              "text-sm": size === "lg",
              "text-xs": size === "sm",
            })}
          >
            {subText}
          </span>
        </div>
        {PillComponent}
      </div>
      <div className={clsx({ "ml-4": !!RightSideComponent })}>
        {RightSideComponent}
      </div>
    </div>
  );
}
